import { Box, Button, SxProps } from "@outschool/backpack";
import React from "react";

interface Props {
  tabs: {
    label: string;
    value: string;
  }[];
  selectedTab: string;
  onChange: (value: string) => void;
  sx?: SxProps;
}

const ClassListTabs = ({ tabs, selectedTab, onChange, sx }: Props) => {
  return (
    <Box flex sx={{ gap: "2.2rem", justifyContent: "center", ...sx }}>
      {tabs.map(tab => (
        <Button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          variant="text"
          disabled={tab.value === selectedTab || tabs.length === 1}
          sx={{
            padding: "0.8rem",
            color: "text.disabled",
            fontSize: "2.2rem",
            fontWeight: 700,
            lineHeight: 1.2,
            backgroundColor: "transparent !important",
            "&:disabled": {
              color: "text.primary",
            },
          }}
        >
          {tab.label}
        </Button>
      ))}
    </Box>
  );
};

export default ClassListTabs;
